import { FC } from 'react';
import { styled } from '../../../../theme/stitches.config';
import { SMPText } from '../../atoms/SMPText';
import { SMPChevronDownIcon } from '../../atoms/icons/SMPChevronDownIcon';

const DropdownButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '$1 $2',
  borderRadius: '$2',
  border: '1px solid $borderMultiSportColor',
  cursor: 'pointer',
  gap: '$1',
  backgroundColor: '$dropdownBtnColor',
  width: '100%',
});

interface DropdownProps {
  selectedOption?: string;
  toggleDropdown: () => void;
}

export const DropdownBtn: FC<DropdownProps> = ({ selectedOption, toggleDropdown }) => {
  return (
    <DropdownButton onClick={toggleDropdown}>
      <SMPText
        css={{
          fontSize: '14px',
          lineHeight: '22px',
          color: '$multiSportTextColor',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {selectedOption}
      </SMPText>
      <SMPChevronDownIcon css={{ width: '$3', height: '$3' }} />
    </DropdownButton>
  );
};
